import React from "react";
import { UserContextSelectors } from "../../redux/selectors/index.js";
import { useSelector } from "react-redux";
import { loadSILinksComponent } from "./loader.js";
import { PageContextUtils } from "../../utils/index.js";

const SILinks = () => {
  const brandId = useSelector(UserContextSelectors.brandId);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const { name } = PageContextUtils.getClientProviderData();
  try {
    const BrandSILinks = loadSILinksComponent(isMobile, brandId, name);
    return BrandSILinks && <BrandSILinks />;
  } catch {
    return null;
  }
};

export default React.memo(SILinks);
